import React, { useEffect, useState } from 'react';
import { Row, Carousel, Button, Container } from 'react-bootstrap';
import './popup.css';
function PopupReviewMedia(props) {
  console.log(props);
  const [paginationIndex, setPaginationIndex] = useState(0);
  let imagesArray = props.images;
  const [mainImg, setMainImg] = useState(props?.images[0]?.image);
  const [videosrc, setVideoSrc] = useState(props?.videos?props?.videos[0]:[]);
  useEffect(()=>{
    setMainImg(props?.images[0]?.image);
    setVideoSrc(props?.videos?props?.videos[0]:[]);
  },[props])
  function scroll(spcl) {
    var doc = document.getElementById("pd_img_list_box_cntn_id");
    if (spcl === "l") {
      doc.scrollLeft -= 200;
    } else {
      doc.scrollLeft += 200;
    }
  }
  function changeImage(item,index){
    let baseImg = item.image;
    // if (item.image.startsWith("products")) {
    //   baseImg = item.image;
    // } else if (item.image.startsWith("mob")) {
    //   baseImg = item.image;
    // } else {
    //   let img = item.image.substr("41");
    //   baseImg = img;
    // }
    setMainImg(baseImg);
    setPaginationIndex(index);
  }

  return (
    <>
      <div className="popup popup-detail review-popup-detail">
        <div className="oM-c">
          <div className='header-pop'>
            <div className="header-title">Media</div>
            <a className="close-pop" onClick={() => props.popupVisibility()}>&times;</a>
          </div>
          <Container className='scroll-y'>
            <div class="d-flex">
                <div className='col-12'>
                    <div className="container">
                        <div className="pd_img_main_box">
                            {imagesArray && imagesArray.length > 0 ? (
                            <><img
                                src={mainImg}
                                className=""
                                alt="img" />
                                <div className="pagination-dot-container">
                                {imagesArray.map((item, index) => {
                                return <div onClick={() => {changeImage(item,index)}} className={`pagination-dot ${paginationIndex==index?"active":""}`}></div>;

                                })}
                                </div></>
                            ) : (
                            <></>
                            )}
                        </div>
                        <div className="image-thumbnail-slider my-4">
                            {imagesArray && imagesArray.length > 3 ? (
                            
                            <img src="/left-slide-icon.webp" className="slider-icon" alt="icon" onClick={() => scroll("l")} />
                            ) : (
                            <></>
                            )}
                            <div
                                className="pd_img_list_box_cntn"
                                id="pd_img_list_box_cntn_id"
                                >
                                {imagesArray.map((item, index) => {
                                    
                                    return (
                                    <div
                                        className={`pd_img_list_box ${paginationIndex==index?"active":""}`}
                                        role="button"
                                        onClick={() => {changeImage(item,index)}}
                                    >
                                        <img
                                        className=""
                                        src={
                                            item.image
                                        }
                                        alt="Product Img"
                                        />
                                    </div>
                                    );
                                })}
                            </div>
                            {imagesArray && imagesArray.length > 3 ? (
                            
                            <img src="/right-slide-icon.webp" className="slider-icon" alt="icon" onClick={() => scroll("r")} />
                            ) : (
                            <></>
                            )}
                        </div>
                        {/* Videos */}
                        {/* videosrc, setVideoSrc */}
                        {props?.videos && props?.videos.length > 0 ?
                        <>
                            <div className="pd_video_main_box mt-3">
                            {/* { videosrc?.includes("products") ?
                                <video
                                controls
                                className=""
                                src={"https://media.toolsvilla.com/" + videosrc}
                                alt="Product Img"
                                />
                                :
                                <video
                                controls
                                className=""
                                src={"https://www.youtube.com/embed/" + videosrc}
                                alt="Product Img"
                            />} */}
                            { props?.videos.map((item) => (
                            <video
                                controls
                                className=""
                                src={item.video}
                                alt="Product Img"
                            />
                            ))}
                            </div>
                        
                            </>:""
                        }
                        {props?.videos && props?.videos.length > 0 ?
                            <div className="video-thumbnail">
                            {
                            props?.videos.map((item, index) => {
                                return <img onClick={()=>setVideoSrc(item.video)} className={props?.videos.indexOf(videosrc)==index?"active":""} src="/video-thumb.webp" alt="thumbnail" />
                            })
                            }
                            </div>:<></>
                        }
                
                    </div>
                </div>

            </div>
          </Container>

        </div>
      </div>
    </>
  )
}

export default PopupReviewMedia;